var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      ref: "attplan",
      staticClass: "rounded-lg pa-3 white",
      attrs: { fluid: "" },
    },
    [
      _vm.loading
        ? _c(
            "v-sheet",
            {
              staticClass:
                "\n      loading_container\n      text-center\n      d-flex\n      align-center\n      justify-center\n      fill-height\n      rounded-lg\n    ",
              attrs: { width: _vm.$refs["attplan"].offsetWidth },
            },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  size: "20",
                  width: "2",
                  color: "primary",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-row",
        {
          staticClass: "mb-2",
          staticStyle: { height: "32px" },
          attrs: { dense: "", "no-gutters": "" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "text-center pa-0 align-center d-flex justify-start",
              attrs: { md: "12" },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "text-button primary--text mr-4",
                  attrs: {
                    small: "",
                    color: "white",
                    shaped: "",
                    disabled:
                      _vm.$getDateTime(new Date(), "YYYY-MM-DD") ===
                      _vm.curDate,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onTrigerPage(null)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("label_essweb_system_todayLabel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "transparent",
                  attrs: { icon: "", small: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.onTrigerPage("red")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons-round" }, [
                    _vm._v("chevron_left"),
                  ]),
                ]
              ),
              _c(
                "v-sheet",
                {
                  staticClass:
                    "mx-6 text-capitalize text-button text--secondary",
                  attrs: { color: "transparent" },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("label_system_date_YMDLabel", {
                          year: _vm.$getDateTime(_vm.startTime, "YYYY"),
                          month: _vm.$getDateTime(_vm.startTime, "MM"),
                          day: _vm.$getDateTime(_vm.startTime, "DD"),
                        }) +
                          " - " +
                          _vm.$t("label_system_date_YMDLabel", {
                            year: _vm.$getDateTime(_vm.endTime, "YYYY"),
                            month: _vm.$getDateTime(_vm.endTime, "MM"),
                            day: _vm.$getDateTime(_vm.endTime, "DD"),
                          })
                      )
                  ),
                ]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "transparent",
                  attrs: { icon: "", small: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.onTrigerPage("add")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons-round" }, [
                    _vm._v("chevron_right"),
                  ]),
                ]
              ),
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    transition: "scale-transition",
                    "offset-y": "",
                    "min-width": "auto",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "ml-4 transparent",
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    color: "secondary",
                                    readonly: "",
                                  },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c(
                                "span",
                                { staticClass: "material-icons-round" },
                                [_vm._v("event")]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.selectedDay,
                    callback: function ($$v) {
                      _vm.selectedDay = $$v
                    },
                    expression: "selectedDay",
                  },
                },
                [
                  _c("v-date-picker", {
                    attrs: {
                      "no-title": "",
                      "show-current": false,
                      color: "primary",
                      flat: "",
                      scrollable: "",
                      "day-format": function (date) {
                        return _vm.$getDateTime(date, "D")
                      },
                      locale: _vm.defaultLang,
                    },
                    on: { input: _vm.onSelectDay },
                    model: {
                      value: _vm.curDate,
                      callback: function ($$v) {
                        _vm.curDate = $$v
                      },
                      expression: "curDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        {
          staticClass: "pb-0",
          staticStyle: {
            "border-bottom": "1px solid var(--main-border-color)",
            height: "50px",
          },
          attrs: { dense: "", "no-gutters": "" },
        },
        _vm._l(_vm.cycleType + 1, function (n) {
          return _c(
            "v-col",
            {
              key: n + "col",
              staticClass: "text-center fill-height pa-0 align-center",
              style: {
                borderRight:
                  n == 1 ? "1px solid var(--main-border-color)" : "none",
              },
              attrs: { cols: n === 1 ? 2 : undefined },
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "pa-0 fill-height align-end align-items-end",
                  attrs: { elevation: 0, tile: "" },
                },
                [
                  n != 1
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "fill-height max-width d-flex justify-end flex-column",
                          },
                          [
                            _c("DaySelect", {
                              attrs: {
                                time: _vm.curPageDate[n - 2],
                                selectStartDate: _vm.selectStartDate,
                                selectEndDate: _vm.selectEndDate,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "v-container",
        {
          staticClass: "max-width pa-0 ma-0 rounded-lg scroll",
          style: {
            overflow: "overlay",
            height: _vm.$vuetify.breakpoint.height - 460 + 46 + "px",
          },
          attrs: { fluid: "" },
        },
        [
          _vm.RosterList.length <= 0
            ? _c("v-sheet", { attrs: { height: "300" } })
            : _vm._e(),
          _vm._l(_vm.RosterList, function (tr, index) {
            return _c(
              "v-row",
              {
                key: index + "roster",
                staticClass: "max-width flex-wrap",
                staticStyle: { height: "100px" },
                attrs: { dense: "", "no-gutters": "" },
              },
              _vm._l(_vm.cycleType + 1, function (n) {
                return _c(
                  "v-col",
                  {
                    key: n + "col",
                    staticClass:
                      "text-center max-width fill-height align-center",
                    style: {
                      borderRight:
                        n == 1 ? "1px solid var(--main-border-color)" : "none",
                    },
                    attrs: { cols: n === 1 ? 2 : undefined },
                  },
                  [
                    _c("attCard", {
                      attrs: {
                        col: n,
                        curType: _vm.cycleType,
                        curData: tr,
                        selectStaffs: _vm.selectStaffs,
                        iSEdited: _vm.iSEdited,
                        shiftList: _vm.shiftList,
                        selectStartDate: _vm.selectStartDate,
                        selectEndDate: _vm.selectEndDate,
                        curDate: _vm.curPageDate[n - 2],
                      },
                      on: {
                        onShift: function (data, date, master) {
                          _vm.$emit("onShift", data, date, master)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              1
            )
          }),
        ],
        2
      ),
      _vm.RosterList.length
        ? _c(
            "v-row",
            {
              staticStyle: {
                "border-top": "1px solid var(--main-border-color)",
              },
              attrs: { dense: "", "no-gutters": "" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass:
                    "text-center pa-0 align-center d-flex justify-center",
                  attrs: { md: "12" },
                },
                [
                  _c(
                    "v-sheet",
                    {
                      staticClass:
                        "\n          pa-2\n          pb-0\n          max-width\n          d-flex\n          flex-nowrap\n          align-center\n          justify-space-between\n        ",
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "text-caption text--secondary" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.other) +
                              " " +
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_list_components_pagenations_columnLabel"
                                )
                              ) +
                              "(" +
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_list_components_pagenations_totalLabel"
                                )
                              ) +
                              " " +
                              _vm._s(
                                Number(_vm.totalCount) == 0
                                  ? _vm.RosterList.length
                                  : _vm.totalCount
                              ) +
                              " " +
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_list_components_pagenations_columnLabel"
                                )
                              ) +
                              ") "
                          ),
                        ]
                      ),
                      _c("v-spacer"),
                      _c("v-pagination", {
                        staticClass:
                          "text--primary d-inline-block text-truncate text-center",
                        attrs: {
                          color: "grey lighten-2 ",
                          "prev-icon": "navigate_before",
                          "next-icon": "navigate_next",
                          length:
                            Number(_vm.totalCount) == 0
                              ? 1
                              : Math.ceil(
                                  _vm.totalCount /
                                    (_vm.itemsPerPage == -1
                                      ? _vm.totalCount
                                      : _vm.itemsPerPage)
                                ),
                          "total-visible": 7,
                        },
                        model: {
                          value: _vm.page,
                          callback: function ($$v) {
                            _vm.page = $$v
                          },
                          expression: "page",
                        },
                      }),
                      _c("v-spacer"),
                      _c(
                        "span",
                        { staticClass: "text-caption text--secondary pr-1" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_list_components_pagenations_perpageLabel"
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "v-menu",
                        {
                          attrs: { "offset-y": "", small: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "\n                mrc-border-solid\n                text-capitalize\n                pa-0\n                white\n                text-body-2\n                d-flex\n                justify-space-around\n              ",
                                          staticStyle: {
                                            "border-color":
                                              "rgba(0, 0, 0, 0.1) !important",
                                            "border-radius": "6px",
                                            "min-width": "60px",
                                          },
                                          attrs: {
                                            width: "60",
                                            height: "28",
                                            outlined: "",
                                            depressed: "",
                                            text: "",
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.itemsPerPage == -1
                                                ? _vm.$t(
                                                    "label_essweb_list_components_pagenations_selectNumber_allLabel"
                                                  )
                                                : _vm.itemsPerPage
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "i",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("arrow_drop_down")]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2227597776
                          ),
                        },
                        [
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l([10, 20, 50], function (item, index) {
                              return _c(
                                "v-list-item",
                                {
                                  key: index,
                                  on: {
                                    click: function ($event) {
                                      _vm.itemsPerPage = item
                                    },
                                  },
                                },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      _vm._s(
                                        item == -1
                                          ? _vm.$t(
                                              "label_essweb_list_components_pagenations_selectNumber_allLabel"
                                            )
                                          : item
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }